module.exports = {
  Axon: {
    logo: require('./../../img/axonLogo.png'),
    description: `Axon es una publicación cuatrimestral especializada en Ciencias Sociales y Humanidades, que publica avances y resultados de investigación, así como reseñas de libros de reciente publicación sobre temas vinculados a estas áreas. Los trabajos que se publican son arbitrados de manera rigurosa en el sistema internacional de revisión a ciegas por pares. Aparece en los meses de enero, mayo y septiembre.`,
    '1': {
      title: 'Número 1, enero-abril 2018',
      description: `En este primer número de la revista Axon, Editorial T & R ofrece a
      sus lectores seis artículos académicos de universidades de Brasil
      y de México, que abordan temáticas diversas, todas ellas
      vinculadas con las Ciencias Sociales, las Humanidades y la
      Tecnología. Es el inicio de un proyecto académico de un grupo de
      investigadores mexicanos que apuestan por la creación de espacios
      para la publicación científica, ante la relevancia que tiene la
      generación y divulgación del conocimiento.
      <br />Axon es una revista cuatrimestral que se edita en formato
      electrónico, bajo el esquema de evaluación a doble ciego; acepta
      artículos de investigación de docentes y estudiantes de posgrado;
      excepcionalmente, colaboraciones de estudiantes de pregrado con el
      aval de su profesor-asesor.`,
      revistas: [
        {
          nombre: 'Presentación',
          autor: 'Alma Elena Gutiérrez Leyton',
          location: '/revistas/Axon/1/1',
          pdfLocation: '/pdf/Axon/1/1.pdf',
        },
        {
          nombre:
            'El mito del origen africano como referencia identitaria: la danza como expresión cultural en la cual el mito se plasma',
          autor: 'Maria Consuelo Oliveira Santos, Maria de Lourdes Barros da Paixão',
          location: '/revistas/Axon/1/2',
          pdfLocation: '/pdf/Axon/1/2.pdf',
        },
        {
          nombre: 'Cultura de Audiencias Regiomontanas: Percepciones sobre los medios',
          autor: 'Beatriz Elena Inzunza Acedo, Citlalli Sánchez Hernández',
          location: '/revistas/Axon/1/3',
          pdfLocation: '/pdf/Axon/1/3.pdf',
        },
        {
          nombre: 'Los estudios de comunicación política en México, 20 años de investigación',
          autor: 'Alejandra Rodríguez',
          location: '/revistas/Axon/1/4',
          pdfLocation: '/pdf/Axon/1/4.pdf',
        },
        {
          nombre:
            'Construcción de la identidad en estudiantes de periodismo digital: motivaciones y (des)valoración hacia la carrera',
          autor: 'Deyra Melina Guerrero Linares, Juan Manuel Rivera Mendoza, Sonia Alejandra Chávez Treviño',
          location: '/revistas/Axon/1/5',
          pdfLocation: '/pdf/Axon/1/5.pdf',
        },
        {
          nombre:
            'La educación en casa (homeschooling) en familias cristianas del noreste de México: percepciones de padres e hijos de 3 familias',
          autor: 'Daniel Enrique Alvarado Guzmán, Adriana Lucía Montemayor Molina, Ana Goretti Rosales Vargas',
          location: '/revistas/Axon/1/6',
          pdfLocation: '/pdf/Axon/1/6.pdf',
        },
        {
          nombre: 'Estrategias Docentes para Fomentar el Pensamiento Crítico',
          autor: 'María Mayela Pérez Esquivel',
          location: '/revistas/Axon/1/7',
          pdfLocation: '/pdf/Axon/1/7.pdf',
        },
      ],
    },
    '2': {
      title: 'Número 2, mayo-agosto de 2018',
      description: `descripcion del 2`,
      revistas: [
        {
          nombre: 'Presentación. El Periodismo como objeto de estudio',
          autor: 'Alma Elena Gutiérrez Leyton',
          location: '/revistas/Axon/2/1',
          pdfLocation: '/pdf/Axon/2/1.pdf',
        },
        {
          nombre:
            'Los estudios de periodismo en la Asociación Mexicana de Investigadores de la Comunicación (AMIC), un lugar ganado a pulso',
          autor: 'Elvira Hernández Carballido',
          location: '/revistas/Axon/2/2',
          pdfLocation: '/pdf/Axon/2/2.pdf',
        },
        {
          nombre:
            'Prensa capturada. Violencia y publicidad oficial obstaculizan la modernización del periodismo mexicano',
          autor: 'Rubén Arnoldo González Macías',
          location: '/revistas/Axon/2/3',
          pdfLocation: '/pdf/Axon/2/3.pdf',
        },
        {
          nombre: 'Autonomía y Violencia: el periodista de la región Noreste de México',
          autor: 'José Luis Lemini Camarillo',
          location: '/revistas/Axon/2/5',
          pdfLocation: '/pdf/Axon/2/5.pdf',
        },
        // {
        //   nombre:
        //     "Entrenamiento especializado para periodistas locales dentro un entorno violento: La iniciativa colombiana",
        //   autor: "Yennué Zárate Valderrama",
        //   location: "/revistas/Axon/2/6",
        //   pdfLocation: "/pdf/Axon/2/6.pdf"
        // },
        {
          nombre: 'Estrategias de control de la clase política en las redes sociales',
          autor: 'Guadalupe H. Mar Vázquez, Carlos E. Villarreal Morales y Edelmira del C. García Díaz',
          location: '/revistas/Axon/2/7',
          pdfLocation: '/pdf/Axon/2/7.pdf',
        },
        {
          nombre:
            'Visión de los egresados de la UAJT que desarrollan periodismo digital de manera independiente en el estado de Tabasco',
          autor: 'Rocío López Martínez',
          location: '/revistas/Axon/2/8',
          pdfLocation: '/pdf/Axon/2/8.pdf',
        },
        {
          nombre: 'Información oficial sobre delitos en Jalisco y su correspondencia en la prensa',
          autor: 'Gabriela Gómez Rodríguez',
          location: '/revistas/Axon/2/9',
          pdfLocation: '/pdf/Axon/2/9.pdf',
        },
        {
          nombre: 'La prensa mexiquense:	entre el	 privilegio y la adversidad: 95 años y contando',
          autor: 'Patricia Maldonado',
          location: '/revistas/Axon/2/10',
          pdfLocation: '/pdf/Axon/2/10.pdf',
        },
        {
          nombre: 'La historia del Premio Nacional de Periodismo',
          autor: 'Elvira Hernández Carballido, Luz Martínez Hernández y Luis Jesús Yáñez González',
          location: '/revistas/Axon/2/12',
          pdfLocation: '/pdf/Axon/2/12.pdf',
        },
        {
          nombre:
            'El periodismo de datos como técnica de la investigación periodística: el caso del reportaje “Peligro. Accidentes carreteros en Colima”',
          autor: 'Aideé C. Arellano Ceballos y Arnoldo Delgadillo Grajeda',
          location: '/revistas/Axon/2/13',
          pdfLocation: '/pdf/Axon/2/13.pdf',
        },
        {
          nombre:
            'Afectaciones en la salud física y mental de los periodistas que cubren noticias sobre violencia y crimen organizado en el Noreste de México',
          autor: 'Luis Beza y Alma Elena Gutiérrez Leyton',
          location: '/revistas/Axon/2/14',
          pdfLocation: '/pdf/Axon/2/14.pdf',
        },
        {
          nombre:
            'Informar sobre narcotráfico en Michoacán. El uso de evidenciales en la prensa escrita como estrategia para evadir responsabilidad',
          autor: 'Édgar Ávila González y Gabriela Sánchez Medina',
          location: '/revistas/Axon/2/15',
          pdfLocation: '/pdf/Axon/2/15.pdf',
        },
        {
          nombre: 'Prácticas y rutinas del periodismo cinematográfico en México',
          autor: 'Ginés Alfonso Navarro Palazuelos',
          location: '/revistas/Axon/2/16',
          pdfLocation: '/pdf/Axon/2/16.pdf',
        },
        {
          nombre: 'Las condicionantes del trabajo periodístico de la fuente deportiva en el estado de Sonora.',
          autor: 'Ángel Iván Húguez Sánchez y Mireya Márquez-Ramírez',
          location: '/revistas/Axon/2/17',
          pdfLocation: '/pdf/Axon/2/17.pdf',
        },
        {
          nombre:
            'La construcción de la memoria y la identidad cultural de los saltillenses a través de notas periodísticas sobre el pan de pulque y el Merendero Saltillo',
          autor: 'Miguel Sánchez Maldonado y Jesús Salas Cortés',
          location: '/revistas/Axon/2/18',
          pdfLocation: '/pdf/Axon/2/18.pdf',
        },
        {
          nombre: 'Publicación de noticias con contenidos educativos en los diarios matutinos de Monterrey',
          autor: 'Sergio Manuel de la Fuente Valdez, Yolanda López Lara y María Mirna Granat Ramos',
          location: '/revistas/Axon/2/19',
          pdfLocation: '/pdf/Axon/2/19.pdf',
        },
        {
          nombre: 'Reformulación analítica no marcada y omisión del declarante en titulares',
          autor: 'Juan Nadal Palazón',
          location: '/revistas/Axon/2/20',
          pdfLocation: '/pdf/Axon/2/20.pdf',
        },
        {
          nombre:
            'Estudio del encuadre en la información periodística del caso de Florence Cassez a través del Modelo de Activación en Cascada de Entman',
          autor: 'Elizabeth Tiscareño García',
          location: '/revistas/Axon/2/21',
          pdfLocation: '/pdf/Axon/2/21.pdf',
        },
        {
          nombre:
            'Objetividad y periodismo. A la búsqueda de una fundamentación significativa del quehacer periodístico a través de “sentido y referencia” de Gottlob Frege',
          autor: 'Francisco Manuel Lorenzo Valdés',
          location: '/revistas/Axon/2/22',
          pdfLocation: '/pdf/Axon/2/22.pdf',
        },
        {
          nombre: 'El periodismo cultural como elemento para repensar la política',
          autor: 'Lorena Rocío Arvizu Rivera',
          location: '/revistas/Axon/2/23',
          pdfLocation: '/pdf/Axon/2/23.pdf',
        },
        {
          nombre: '¿Twitter nuevo género periodístico en elecciones 2018?',
          autor: 'José Luis Palacios Islas',
          location: '/revistas/Axon/2/24',
          pdfLocation: '/pdf/Axon/2/24.pdf',
        },
        {
          nombre:
            'Procesos electorales 2018: La representación de la mujer como actor político en los medios impresos, a nivel estatal, durante la etapa de precampaña en el estado de Guerrero',
          autor: 'Aurora Reyes Galván y Denia May Sánchez Rivera',
          location: '/revistas/Axon/2/25',
          pdfLocation: '/pdf/Axon/2/25.pdf',
        },
        {
          nombre:
            'Seguimiento de la cobertura en primera plana de candidatos presidenciales en tres diarios de circulación nacional',
          autor: 'Rubén Flores González, Indra Juárez Vera y Erick Rubén Caicero López',
          location: '/revistas/Axon/2/26',
          pdfLocation: '/pdf/Axon/2/26.pdf',
        },
        {
          nombre: 'Violentómetro periodístico del sur de Tamaulipas',
          autor: 'Dulce Alexandra Cepeda-Robledo',
          location: '/revistas/Axon/2/27',
          pdfLocation: '/pdf/Axon/2/27.pdf',
        },
      ],
    },
    '3': {
      title: 'Número 3, septiembre-diciembre de 2018',
      description: `descripcion del 3`,
      revistas: [
        {
          nombre: 'Presentación del Número 3',
          autor: 'Alma Elena Gutiérrez Leyton',
          location: '/revistas/Axon/3/1',
          pdfLocation: '/pdf/Axon/3/1.pdf',
        },
        {
          nombre: 'Pensar en el conocimiento de frontera y las nuevas formas de significar',
          autor: 'Luis Eduardo Primero Rivas',
          location: '/revistas/Axon/3/2',
          pdfLocation: '/pdf/Axon/3/2.pdf',
        },
        {
          nombre: 'La ciudadanía: reflexión y participación para el cambio social',
          autor: 'Ángel Lorenzo Ramírez Rodríguez',
          location: '/revistas/Axon/3/3',
          pdfLocation: '/pdf/Axon/3/3.pdf',
        },
        {
          nombre: 'La educación sexual femenina: una revolución truncada de origen',
          autor: 'Sarai Aguilar Arriozola',
          location: '/revistas/Axon/3/4',
          pdfLocation: '/pdf/Axon/3/4.pdf',
        },
        {
          nombre:
            'Interrelación de la Universidad con la investigación e innovación y su aporte al desarrollo del país',
          autor: 'Roberto Vladimir Carbajal Amaya',
          location: '/revistas/Axon/3/5',
          pdfLocation: '/pdf/Axon/3/5.pdf',
        },
        {
          nombre: '¿Cómo se lee ahora? Las nuevas modalidades de la lectura en jóvenes universitarios',
          autor: 'Graciela Ceballos de la Mora, Aideé Arellano Ceballos',
          location: '/revistas/Axon/3/6',
          pdfLocation: '/pdf/Axon/3/6.pdf',
        },
        {
          nombre:
            'Educación ambiental: percepción, conciencia y expectativas sustentables en estudiantes de bachillerato',
          autor: 'Cristina Aracely Ramírez de la Garza',
          location: '/revistas/Axon/3/7',
          pdfLocation: '/pdf/Axon/3/7.pdf',
        },
        {
          nombre: 'El insulto y los apodos: objetivaciones léxicas de la violencia escolar en el occidente mexicano',
          autor: 'Emilio Gerzaín Manzo Lozano, Ciria Margarita Salazar, Aideé Consuelo Arellano Ceballos',
          location: '/revistas/Axon/3/8',
          pdfLocation: '/pdf/Axon/3/8.pdf',
        },
        {
          nombre: 'Habilidades cognitivas que adquieren los alumnos de preescolar que ejecutan algún instrumento',
          autor: 'Martha Paola Garay Mendoza',
          location: '/revistas/Axon/3/9',
          pdfLocation: '/pdf/Axon/3/9.pdf',
        },
      ],
    },
    '4': {
      title: 'Número 4, enero-abril de 2019',
      description: `descripcion del 4`,
      revistas: [
        {
          nombre: 'Presentación del Número 4',
          autor: 'Alma Elena Gutiérrez Leyton',
          location: '/revistas/Axon/4/1',
          pdfLocation: '/pdf/Axon/4/1.pdf',
        },
        {
          nombre: 'La Educación Ambiental para el Desarrollo Sustentable de la UANL',
          autor: 'Raymundo de Jesús Guerra Flores',
          location: '/revistas/Axon/4/2',
          pdfLocation: '/pdf/Axon/4/2.pdf',
        },
        {
          nombre: 'Redes Sociales: Hacia un nuevo y efectivo canal de comunicación entre el gobierno y la ciudadanía',
          autor: 'Rosa Lilibeth Lira Salazar',
          location: '/revistas/Axon/4/3',
          pdfLocation: '/pdf/Axon/4/3.pdf',
        },
        {
          nombre: 'Un “me gusta” en redes sociales no es un voto en la política local',
          autor: 'José Luis Herrera Duque',
          location: '/revistas/Axon/4/4',
          pdfLocation: '/pdf/Axon/4/4.pdf',
        },
        {
          nombre:
            'Factores que determinan la existencia de ciberacoso en los estudiantes de secundaria: Un estudio en Monterrey y su área metropolitana',
          autor: 'Fernando Arturo Álvarez Morales',
          location: '/revistas/Axon/4/5',
          pdfLocation: '/pdf/Axon/4/5.pdf',
        },
        {
          nombre: 'Fotoperiodismo: la importancia del oficio',
          autor: 'Teresa Geraldina González Villagómez',
          location: '/revistas/Axon/4/6',
          pdfLocation: '/pdf/Axon/4/6.pdf',
        },
      ],
    },
    '5': {
      title: 'Número 5, mayo-agosto de 2019',
      description: `descripcion del 5`,
      revistas: [
        {
          nombre: 'Presentación del Número 5',
          autor: 'Alma Elena Gutiérrez Leyton',
          location: '/revistas/Axon/5/1',
          pdfLocation: '/pdf/Axon/5/1.pdf',
        },
        {
          nombre: 'Estrategias para mejorar la tutoría por medio de la psicología positiva',
          autor:
            'Martha Paola Garay, Alfredo Roberto Holguín Rubio, José Guadalupe Villarreal Hernández, Sandra Guadalupe Altamirano Galván',
          location: '/revistas/Axon/5/2',
          pdfLocation: '/pdf/Axon/5/2.pdf',
        },
        {
          nombre: 'La representación de la Liga MX femenil en cinco medios digitales mexicanos',
          autor: 'Fredi de Jesús Figueroa González',
          location: '/revistas/Axon/5/3',
          pdfLocation: '/pdf/Axon/5/3.pdf',
        },
        {
          nombre: 'El proceso creativo musical y su relación con efectos patológicos mentales',
          autor: 'Martha Paola Garay Mendoza',
          location: '/revistas/Axon/5/4',
          pdfLocation: '/pdf/Axon/5/4.pdf',
        },
      ],
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/revistas/revistasData.js